import { IGame } from 'src/app/models/game';

export const scuttlebugDerby: IGame = {
    embedId: 1275174,
    name: 'Scuttlebug Derby',
    url: 'scuttlebug-derby'
};
